/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dev_Menu_SaveInputs */

const en_dev_menu_save = /** @type {(inputs: Dev_Menu_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

const ar_dev_menu_save = /** @type {(inputs: Dev_Menu_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حفظ`)
};

const bn_dev_menu_save = /** @type {(inputs: Dev_Menu_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সেভ করুন`)
};

const de_dev_menu_save = /** @type {(inputs: Dev_Menu_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern`)
};

const es_dev_menu_save = /** @type {(inputs: Dev_Menu_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar`)
};

const fr_dev_menu_save = /** @type {(inputs: Dev_Menu_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

const pt_dev_menu_save = /** @type {(inputs: Dev_Menu_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar`)
};

const zh_dev_menu_save = /** @type {(inputs: Dev_Menu_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存`)
};

const tr_dev_menu_save = /** @type {(inputs: Dev_Menu_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaydet`)
};

const ru_dev_menu_save = /** @type {(inputs: Dev_Menu_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить`)
};

const pl_dev_menu_save = /** @type {(inputs: Dev_Menu_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisz`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Dev_Menu_SaveInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const dev_menu_save = /** @type {((inputs?: Dev_Menu_SaveInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dev_Menu_SaveInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_dev_menu_save(inputs)
	if (locale === "bn") return bn_dev_menu_save(inputs)
	if (locale === "de") return de_dev_menu_save(inputs)
	if (locale === "es") return es_dev_menu_save(inputs)
	if (locale === "fr") return fr_dev_menu_save(inputs)
	if (locale === "pt") return pt_dev_menu_save(inputs)
	if (locale === "zh") return zh_dev_menu_save(inputs)
	if (locale === "tr") return tr_dev_menu_save(inputs)
	if (locale === "ru") return ru_dev_menu_save(inputs)
	if (locale === "pl") return pl_dev_menu_save(inputs)
	return en_dev_menu_save(inputs)
});